export const splitName = (value: string): { firstname: string; lastname: string } => {
    const nameParts = value.split(' ');
    const lastname = nameParts.pop() || '';
    const firstname = nameParts.join(' ');
    return { firstname, lastname };
};
